import { Controller } from 'stimulus'

export default class extends Controller {
  static values = { "url": String }

  connect() {
    this.brandStyleInterval = setInterval(() => {
      this.checkForBrandStyles()
    }, 5000)
  }

  checkForBrandStyles() {
    $.ajax({
      type: 'GET',
      dataType: 'json',
      url: this.urlValue,
      success: (response) => {
        if (Number(response.brand_styles) > 0) {
          clearInterval(this.brandStyleInterval)
          return window.location.reload()
        }
      },
      error: () => {},
    })

  }
}
